import { render, staticRenderFns } from "./PurchasedPackages.vue?vue&type=template&id=3ee3b513&scoped=true&"
import script from "./PurchasedPackages.vue?vue&type=script&lang=js&"
export * from "./PurchasedPackages.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedPackages.vue?vue&type=style&index=0&id=3ee3b513&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3b513",
  null
  
)

export default component.exports